
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Koregaonparktomumbaicabservice() {



    const cardData =
    {
        keyword: 'Koregaon Park to Mumbai Cab Service',
        heading: 'Meghana Cab : Koregaon Park to Mumbai Cab Service',
        headingDescription: 'Meghana Cab offers Koregaon Park to Mumbai Cab Service, providing a luxurious and reliable travel option from Pune’s elite locality to Mumbai. Whether you’re traveling for business, a weekend escape, or an airport drop, our service ensures a smooth and timely journey. Choose from a range of well-maintained vehicles including Sedans, SUVs, Innova Crysta, and Tempo Travellers to match your comfort and group size. With door-to-door pickups from Koregaon Park, experienced chauffeurs, transparent fares, and 24/7 customer assistance, book your Koregaon Park to Mumbai Cab with Meghana Cab for a stress-free and premium intercity travel experience.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [
   
 {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
   {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Koregaon Park to Mumbai One Way Cab",
        "description": "Experience hassle-free one-way cab service from Koregaon Park to Mumbai with our reliable fleet. Whether you’re heading to the airport, a business meeting, or a family event, enjoy a comfortable and timely ride with professional drivers and well-maintained vehicles."
    },
    {
        "name": "Round Trip Taxi Koregaon Park to Mumbai",
        "description": "Book a convenient round-trip taxi from Koregaon Park to Mumbai and back. Perfect for business travelers or leisure tourists, our service offers flexible scheduling, competitive pricing, and courteous chauffeurs to ensure your journey is smooth and stress-free."
    },
    {
        "name": "AC Cab Koregaon Park to Mumbai",
        "description": "Travel in cool comfort with our air-conditioned cab service from Koregaon Park to Mumbai. Ideal for long-distance journeys or hot weather, our AC cabs provide a relaxing environment along with professional drivers to make your trip pleasant."
    },
    {
        "name": "Online Booking Cab Koregaon Park to Mumbai",
        "description": "Book your cab from Koregaon Park to Mumbai easily through our secure online platform. Get instant confirmation, multiple payment options, and access to a variety of vehicles suited to your travel needs."
    },
    {
        "name": "Budget Cab Koregaon Park to Mumbai",
        "description": "Looking for affordable travel options? Our budget cab service from Koregaon Park to Mumbai offers clean, fuel-efficient vehicles with dependable service, ensuring you get value for money without compromising comfort or safety."
    },
    {
        "name": "SUV Hire Koregaon Park to Mumbai",
        "description": "Need extra space for luggage or group travel? Our SUV hire service from Koregaon Park to Mumbai provides spacious seating, powerful performance, and comfort for families or corporate groups, making your long drive enjoyable."
    },
    {
        "name": "Private Taxi Koregaon Park to Mumbai",
        "description": "Enjoy privacy and personalized service with our private taxi hire from Koregaon Park to Mumbai. Whether for business or personal use, our dedicated drivers ensure a safe, comfortable, and exclusive travel experience."
    },
    {
        "name": "Sedan Cab Koregaon Park to Mumbai",
        "description": "Choose our sedan cab service from Koregaon Park to Mumbai for a stylish and comfortable ride. Our sedans are perfect for solo travelers, couples, or small groups seeking efficient and elegant transportation."
    },
    {
        "name": "Family Travel Cab Koregaon Park to Mumbai",
        "description": "Travel with your family safely and comfortably using our family travel cabs from Koregaon Park to Mumbai. We provide spacious vehicles, friendly drivers, and convenient pickup/drop-off options tailored to family needs."
    },
    {
        "name": "Corporate Cab Koregaon Park to Mumbai",
        "description": "Make your corporate travel seamless with our dedicated corporate cab service from Koregaon Park to Mumbai. Benefit from professional chauffeurs, timely pickups, and billing options designed for business travelers."
    },
    {
        "name": "Chauffeur Driven Taxi Koregaon Park to Mumbai",
        "description": "Experience luxury and convenience with our chauffeur-driven taxi service from Koregaon Park to Mumbai. Our experienced drivers prioritize your safety and comfort, making your trip relaxing and stress-free."
    },
    {
        "name": "Fast Cab Booking Koregaon Park to Mumbai",
        "description": "In a hurry? Our fast cab booking service from Koregaon Park to Mumbai offers instant confirmation and quick dispatch, ensuring you reach your destination on time without any delays."
    },
    {
        "name": "Long Distance Koregaon Park to Mumbai Cab",
        "description": "Planning a long-distance trip from Koregaon Park to Mumbai? Our long-distance cab service offers comfortable vehicles, skilled drivers, and flexible schedules to make your extended journey safe and enjoyable."
    },
    {
        "name": "24-Hour Cab Service Koregaon Park to Mumbai",
        "description": "Our 24-hour cab service from Koregaon Park to Mumbai is available around the clock to meet your travel needs anytime, day or night. Perfect for late-night flights or early morning meetings."
    },
    {
        "name": "Premium Cab Koregaon Park to Mumbai",
        "description": "Upgrade your travel experience with our premium cab service from Koregaon Park to Mumbai. Featuring luxury vehicles, exceptional customer care, and professional chauffeurs, ideal for VIPs and special occasions."
    }
],
"tableData": [
    ["Koregaon Park to Mumbai One Way Cab", "Round Trip Taxi Koregaon Park to Mumbai"],
    ["AC Cab Koregaon Park to Mumbai", "Online Booking Cab Koregaon Park to Mumbai"],
    ["Budget Cab Koregaon Park to Mumbai", "SUV Hire Koregaon Park to Mumbai"],
    ["Private Taxi Koregaon Park to Mumbai", "Sedan Cab Koregaon Park to Mumbai"],
    ["Family Travel Cab Koregaon Park to Mumbai", "Corporate Cab Koregaon Park to Mumbai"],
    ["Chauffeur Driven Taxi Koregaon Park to Mumbai", "Fast Cab Booking Koregaon Park to Mumbai"],
    ["Long Distance Koregaon Park to Mumbai Cab", "24-Hour Cab Service Koregaon Park to Mumbai"],
    ["Premium Cab Koregaon Park to Mumbai", ""]
],






"whychoose": [
    {
        "WhyChooseheading": "Premium Cab Service from Koregaon Park to Mumbai",
        "WhyChoosedescription": "Our Koregaon Park to Mumbai cab service offers a blend of luxury, convenience, and punctuality. Whether you're traveling for business, leisure, or an airport transfer, we ensure a seamless experience from start to finish."
    },
    {
        "WhyChooseheading": "Well-Maintained and Comfortable Vehicles",
        "WhyChoosedescription": "Enjoy a smooth ride in our clean, air-conditioned cabs featuring spacious interiors and plush seating. Our fleet includes sedans, SUVs, and executive-class vehicles to match your comfort and travel needs."
    },
    {
        "WhyChooseheading": "Experienced and Courteous Chauffeurs",
        "WhyChoosedescription": "All our drivers are professionally trained, background-verified, and familiar with the Koregaon Park to Mumbai route. They drive responsibly and ensure your journey is not only safe but also pleasant and respectful."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
        "WhyChoosedescription": "Get upfront pricing with no surprises. Our fares include all costs—tolls, driver allowances, fuel, and taxes. You receive a complete breakdown before you book, so you can travel with confidence and clarity."
    },
    {
        "WhyChooseheading": "Flexible Booking and Travel Customization",
        "WhyChoosedescription": "Book a one-way drop, round trip, or hourly rental as per your plan. We offer customizable pickup/drop-off locations and travel schedules, making it easy to adapt your ride to your personal or professional commitments."
    },
    {
        "WhyChooseheading": "Door-to-Door Pickup and Drop-off",
        "WhyChoosedescription": "We offer direct cab service from your location in Koregaon Park to any part of Mumbai. Avoid public transport and long walks—our cab comes right to your door and takes you exactly where you need to go."
    },
    {
        "WhyChooseheading": "Ideal for Airport Transfers, Corporate Travel, and Day Trips",
        "WhyChoosedescription": "Whether heading to Mumbai International Airport, attending a business meeting, or planning a city visit, our service is ideal for all travel purposes. We ensure comfort, reliability, and peace of mind on every ride."
    },
    {
        "WhyChooseheading": "24/7 Support and Online Booking Assistance",
        "WhyChoosedescription": "Book anytime via our website or customer helpline. Our support team is available 24/7 to help with bookings, changes, or any travel-related queries—ensuring a smooth experience every step of the way."
    }
]

























    }

const faqData = [
    {
        question: "How do I book a cab from Koregaon Park to Mumbai?",
        answer: "You can book a cab by calling Meghana Cab at +91 9075462128 or through our website for quick and hassle-free booking."
    },
    {
        question: "What is the estimated travel time from Koregaon Park to Mumbai by cab?",
        answer: "The journey generally takes around 3 to 4 hours, depending on traffic conditions."
    },
    {
        question: "Are one way and round trip cab services available from Koregaon Park to Mumbai?",
        answer: "Yes, Meghana Cab offers both one way and round trip options to suit your travel needs."
    },
    {
        question: "What types of vehicles are available for the Koregaon Park to Mumbai route?",
        answer: "We provide hatchbacks, sedans, SUVs, and tempo travellers depending on your group size and preferences."
    },
    {
        question: "Is the cab service from Koregaon Park to Mumbai available 24/7?",
        answer: "Yes, our service operates 24/7 to ensure you can book a cab anytime."
    },
    {
        question: "Does the fare include tolls, fuel, and driver charges?",
        answer: "Yes, our fare includes all these charges. Additional waiting or parking fees may apply."
    },
    {
        question: "Can I book a cab from Koregaon Park to Mumbai on short notice?",
        answer: "Yes, last-minute bookings are accepted subject to vehicle availability. Please contact us directly for urgent bookings."
    },
    {
        question: "Is online booking available for Koregaon Park to Mumbai cabs?",
        answer: "Absolutely, you can book online anytime via our website with secure payment options."
    },
    {
        question: "Can I request stops during the trip for meals or breaks?",
        answer: "Yes, you can request stops. Please inform us during booking or notify the driver."
    },
    {
        question: "Are your drivers experienced with the Koregaon Park to Mumbai route?",
        answer: "Yes, our drivers are professional and knowledgeable about the best routes for a safe journey."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Shashank Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Travelled from Koregaon Park to Mumbai with Meghana Cab. The service was reliable and the vehicle very comfortable.”',
    },
    {
        name: 'Ms. Priya Deshpande',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booking online was seamless and the driver was punctual. Highly recommend Meghana Cab for this route.”',
    },
];























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Koregaon Park to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/koregaon-park-to-mumbai-cab.jpg",
  "description": "Book reliable and affordable cabs from Koregaon Park to Mumbai with Meghana Cabs. Choose from AC Sedans, SUVs, and chauffeur-driven cars. Available for one-way and round trips with 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1899",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/koregaon-park-to-mumbai-cab-service"
  }
};









    return (
        <div>
<Helmet>
  <title>Koregaon Park to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Affordable and reliable cab service from Koregaon Park to Mumbai by Meghana Cabs. Book AC Sedans, SUVs, or chauffeur-driven cars online. Available 24/7 for one-way and round trip travel." 
  />
  <meta 
    name="keywords" 
    content="Koregaon Park to Mumbai One Way Cab, Round Trip Taxi Koregaon Park to Mumbai, AC Cab Koregaon Park to Mumbai, Online Booking Cab Koregaon Park to Mumbai, Budget Cab Koregaon Park to Mumbai, SUV Hire Koregaon Park to Mumbai, Private Taxi Koregaon Park to Mumbai, Sedan Cab Koregaon Park to Mumbai, Family Travel Cab Koregaon Park to Mumbai, Corporate Cab Koregaon Park to Mumbai, Chauffeur Driven Taxi Koregaon Park to Mumbai, Fast Cab Booking Koregaon Park to Mumbai, Long Distance Koregaon Park to Mumbai Cab, 24-Hour Cab Service Koregaon Park to Mumbai, Premium Cab Koregaon Park to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/69.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Koregaonparktomumbaicabservice;